const state = {
  page: 1,
  total: 0,
  limit: 10
}

const actions = {
  // 获取班级评价列表
  async mlzStudentEvaListGetData ({ commit, state }, playload) {
    const res = await API.get(`${CONFIG.mlz_teacher_api}/instructor/kps-study-student-evaluate/byAttendanceId/${playload}?page=${state.page}&limit=${state.limit}`)
    return res
  }
}

const mutations = {

}

export default {
  state,
  actions,
  mutations
}
